import { useFunzioni } from './featureFlags';

/** Mostra `children` se l'interruttore `chiave` (Impostazioni › Funzioni) e` acceso, altrimenti `altrimenti`. */
export const FunzioneAccesa = ({ chiave, children, altrimenti = null }) => (useFunzioni()[chiave] ? children : altrimenti);

export default FunzioneAccesa;
